
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JoinVO } from '@/views/biz/login/vo/JoinVO.vo'
import { LoginVO } from '@/views/biz/login/vo/LoginVO.vo'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'


import axios from 'axios';

@Component
export default class Login extends Vue {
  member: MemberVO = {} as MemberVO;

  // 로그인
  loginVO: LoginVO = {} as LoginVO;
  showPassword1 = false;
  loading1 = false;
  loginError = true;
  // 회원가입 
  joinVO: JoinVO = {} as JoinVO;
  mbrPwdConfirm = '';
  showPassword2 = false;
  showPassword3 = false;
  loading2 = false;

  isLogin = true;
  validLogin = false;
  validJoin = false;

  idRules1 = [
    (v: string) => !!v || '아이디를 입력해주세요.',
  ];

  passwordRules1 = [
    (v: string) => !!v || '비밀번호를 입력해주세요.',
    (v: string) => v && this.loginError || '아이디/비밀번호를 확인해주세요.'
  ];

  idRules2 = [
    (v: string) => !!v || '아이디를 입력해주세요.',
    (v: string) => (v && /^[A-Za-z0-9+]*$/.test(v) && v.length <= 12 && v.length >= 5) || '영문/숫자(5자 이상 12자 이하)',
  ];

  passwordRules2 = [
    (v: string) => !!v || '비밀번호를 입력해주세요.',
    (v: string) => (v && /^(?=.*\d{1,10})(?=.*[a-zA-Z]{2,10}).{8,20}/.test(v) && v.length >= 8 && v.length <= 20) || '영문/숫자 조합(8자 이상 20자 이하)',
  ];

  passwordRules3 = [
    (v: string) => !!v || '비밀번호 확인을 입력하세요.',
    (v: string) => (v && /^(?=.*\d{1,10})(?=.*[a-zA-Z]{2,10}).{8,20}/.test(v) && v.length >= 8 && v.length <= 20) || '영문/숫자 조합(8자 이상 20자 이하)',
  ];

  emailRules2= [
    (v: string) => !!v || '비밀번호 분실할 경우 필요한 정보예요.',
    (v: string) => (v && /.+@.+\..+/.test(v)) || '이메일 형식이 올바르지 않아요.',
  ];

  // computed
  get loginSuccessRouterName(): string {
    return this.$route.params.toName || "Main"; // @Prop 으로 못가져옴
  }

  @Watch('isLogin')
  resetFormData() {
    this.mbrPwdConfirm = '';
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.showPassword3 = false;
    this.validLogin = false;
    this.validJoin = false;

    this.loginVO = {} as LoginVO;
    this.joinVO = {} as JoinVO;
  }

  // 로그인
  doLogin(): void {
    if(this.validLogin == false) {
      return
    }
    this.loading1 = true;

    axios.post('/login', this.loginVO)
    .then(r => {
      if (this.loginSuccessRouterName && this.loginSuccessRouterName != 'Login') {
        this.$router.push({
          name: this.loginSuccessRouterName,
          params: this.$route.params
        });
      } else {
        this.$router.push({ name: 'Main' });
      }
    })
    .catch(e => {
      if(e.exceptionName == 'BadCredentialsException') {
        this.loginError = false;
      }
    })
    .finally(() => {
      this.loading1 = false;
    })
  }

  // 회원가입
  doJoin() {
    if(this.validJoin == false) {
      return this.$toast('필수값이 누락되었어요.');
    }

    if(this.mbrPwdConfirm != this.joinVO.mbrPwd) {
      return this.$toast('비밀번호가 일치하지 않아요.');
    }

    axios.post('/join', this.joinVO)
    .then(r=>{
      this.$router.push({ name: 'Main' });
    })
  }

}
